import type { ComponentProps } from 'react';
import { Button } from '@/components/ui/button';
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/components/ui/tooltip';

type IconButtonProps = Omit<
	ComponentProps<typeof Button>,
	'size' | 'aria-label'
> & {
	/** Accessible name, also shown as the tooltip. */
	label: string;
};

/** Icon-only button whose label is shown in a tooltip. */
export function IconButton({ label, children, ...props }: IconButtonProps) {
	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<Button size="icon" aria-label={label} {...props}>
					{children}
				</Button>
			</TooltipTrigger>
			<TooltipContent>{label}</TooltipContent>
		</Tooltip>
	);
}
